export default __webpack_public_path__ + "static/images/jisoo_07.png";